













import { Illustration } from '@superbet-group/web.lib.ui-components';
import {
    computed,
    defineComponent,
} from '@vue/composition-api';

export default defineComponent({
    name: 'CompetitionsEmptyStateBase',
    props: {
        illustrationName: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        return {
            illustrationUrl: computed(() => `/static/img/illustrations/${props.illustrationName}.svg`),
        };
    },
    components: {
        Illustration,
    },
});
